import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery';

import Link from '../helpers/Link';

import HeaderPlaceholder from './HeaderPlaceholder';
import HeaderMenu from './HeaderMenu';
import HeaderLanguage from './HeaderLanguage';

// const SAGITON_URL = 'https://www.sagiton.pl';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            small: false
        };
        this.scroll = this.scroll.bind(this);
        this.resize = this.resize.bind(this);
        this.updateBodyClass = this.updateBodyClass.bind(this);
        this.menuTriggerClick = this.menuTriggerClick.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

        this.previousWindowWidth = $(window).width();
    }

    componentDidMount() {
        window.addEventListener('scroll', this.scroll);
        window.addEventListener('resize', this.resize);

        this.updateBodyClass();
    }

    componentDidUpdate() {
        this.updateBodyClass();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scroll);
        window.removeEventListener('resize', this.resize);
    }

    scroll() {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        const small = (scrollTop > windowHeight / 2);
        this.setState({ small });
    }

    resize() {
        // this prevent an ios bug when resize event is triggered randomly on scroll
        if ($(window).width() !== this.previousWindowWidth) {
            this.previousWindowWidth = $(window).width();
            this.updateBodyClass();
            this.setState({ menuOpen: false });
            this.scroll();
        }
    }

    updateBodyClass() {
        if ((this.props.breakpoint === 'phone' || this.props.breakpoint === 'tablet') && this.state.menuOpen) {
            $('html, body').addClass('mobile-menu-open');
        } else {
            $('html, body').removeClass('mobile-menu-open');
        }
    }

    menuTriggerClick() {
        this.setState({
            menuOpen: !this.state.menuOpen
        });
    }

    closeMenu() {
        this.setState({
            menuOpen: false
        });
    }

    render() {
        const { menuOpen, small } = this.state;
        const {
            t, openPage, language, page, subpage, noTransition
        } = this.props;

        // const menuHeight = $('.header-menu-main').outerHeight(true) + $('.header-language').outerHeight(true) + $('.header-contact').outerHeight(true);
        const containerClassName = cx('container-header', { 'container-header--small': small });
        const triggerClassName = cx('header-menu-trigger', { active: menuOpen });
        const headerMenuContainerClassName = cx('header-menu-container', { open: menuOpen });

        return [
            <HeaderPlaceholder key="header-placeholder"/>,
            <div className={ containerClassName } id="header-menu-container" key="header">
                <div className={ cx('page-header', { 'no-transition': noTransition }) } id="page-header">
                    <div className="header-cover" id="header-cover"/>
                    <div className="header-logo-wrapper">
                        <Link
                          openPage={ openPage }
                          language={ language }
                          className={ cx('header-logo', { 'no-transition': noTransition }) }
                          id="header-logo"
                        >
                            <h1>{ t('header.logo') }</h1>
                        </Link>
                        {/* <a
                          href={ SAGITON_URL }
                          className="header-logo-by-wrapper"
                          id="header-by-logo"
                        >
                            <span className="header-logo-by">by</span>
                            <img className="header-logo-by-brand" src={ require('../../assets/images/Sagiton-Logo.png') } alt="Sagiton"/>
                        </a> */}
                    </div>
                    <div className={ triggerClassName } id={ triggerClassName } onClick={ this.menuTriggerClick }>
                        <span className="line line-1" id="line-1"/>
                        <span className="line line-2a" id="line-2a"/>
                        <span className="line line-2b" id="line-2b"/>
                        <span className="line line-3" id="line-3"/>
                    </div>
                    <Link
                      openPage={ openPage }
                      language={ language }
                      page={ page }
                      subpage={ subpage }
                      query={ { video: '' } }
                      className="header-video-mobile"
                    >
                        { t('header.menu.video') }
                    </Link>
                    <div className={ headerMenuContainerClassName } id={ headerMenuContainerClassName }>
                        <div className="header-menu-mobile" id="header-menu-mobile">
                            <nav className="header-menu" id="header-menu">
                                <HeaderMenu
                                  t={ t }
                                  openPage={ openPage }
                                  language={ language }
                                  page={ page }
                                  closeMenu={ this.closeMenu }
                                />
                                <div className="header-buttons">
                                    <Link
                                      openPage={ openPage }
                                      language={ language }
                                      page={ page }
                                      subpage={ subpage }
                                      query={ { video: '' } }
                                      className="header-button"
                                    >
                                        { t('header.menu.video') }
                                    </Link>
                                </div>
                                <HeaderLanguage
                                  openPage={ openPage }
                                  language={ language }
                                  page={ page }
                                  subpage={ subpage }
                                  closeMenu={ this.closeMenu }
                                />
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        ];
    }
}

Header.defaultProps = {
    subpage: null
};

Header.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    breakpoint: PropTypes.string.isRequired,
    noTransition: PropTypes.bool.isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx